import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import hasCustomPaymentCompletePage from 'src/common/components/payment/utils/hasCustomPaymentCompletePage';
import { useRouteProps } from 'src/common/providers/RoutePropsProvider';
import { selectSubscriptionSuccessPartnerConfig } from 'src/common/selectors/config';
import { isLarge, isXLarge, isXXLarge } from 'src/common/utils/breakpoints';
import { useBreakpoint } from './useBreakpoint';

export default function useSideBar(isMobile, query, pathname) {
  const { isLanding, hideLeft, hideRight, hideRightSideTillXxl, matchUrl, isDiscord } =
    useRouteProps();
  const subscriptionSuccessPartnerConfig = useSelector(selectSubscriptionSuccessPartnerConfig);
  const isLargeBreakpoint = useBreakpoint(isLarge);
  // Right side serves on xxlarge profile pages and xlarge other pages (not on landing page)
  const isRightSideBreakpoint = useBreakpoint(hideRightSideTillXxl ? isXXLarge : isXLarge);
  const isNotLandingOrMobile = !(isLanding || isMobile);
  const isLeftSideDocked = isNotLandingOrMobile && !isDiscord && isLargeBreakpoint;
  const isRightSideOpen = isNotLandingOrMobile && !isDiscord && !hideRight && isRightSideBreakpoint;
  const [isLeftSideOpen, setIsLeftSideOpen] = useState(isLeftSideDocked);

  const shouldHideLeftSide = hasCustomPaymentCompletePage(
    query,
    pathname,
    subscriptionSuccessPartnerConfig,
  );
  const hideLeftSide = hideLeft || shouldHideLeftSide;

  useEffect(() => {
    setIsLeftSideOpen(hideLeftSide ? false : isLeftSideDocked);
  }, [hideLeftSide, matchUrl, isLeftSideDocked]);

  const handleLeftSideToggle = useCallback(() => {
    setIsLeftSideOpen((value) => !value);
  }, []);

  return {
    isLeftSideDocked,
    isLeftSideOpen,
    isRightSideOpen,
    hideLeftSide,
    handleLeftSideToggle,
  };
}
